import { PROJECT_TYPE_LABELS, PROJECT_TYPES } from './commonProjects';
import { API_TAG_TYPES } from './apiTagTypes';

export const ACTIVITY_LOG_CATEGORIES = {
  ...PROJECT_TYPES,
  ORGANISATIONS: 'organisations',
  USERPROFILE: 'userprofile',
};

export const ACTIVITY_LOG_CATEGORIES_LABELS = {
  ...PROJECT_TYPE_LABELS,
  [ACTIVITY_LOG_CATEGORIES.ORGANISATIONS]: 'Organisation',
  [ACTIVITY_LOG_CATEGORIES.USERPROFILE]: 'Users',
};

export const TAG_TYPES_BY_LOG_CATEGORY = {
  [ACTIVITY_LOG_CATEGORIES.ORGANISATIONS]: {
    list: API_TAG_TYPES.ORGANISATIONS,
    items: [API_TAG_TYPES.ORGANISATIONS],
  },
  [ACTIVITY_LOG_CATEGORIES.USERPROFILE]: {
    list: API_TAG_TYPES.ORGANISATION_USERS,
    items: [],
  },
  [ACTIVITY_LOG_CATEGORIES.CULTURE_PROJECT]: {
    list: API_TAG_TYPES.ORGANISATION_PROJECTS,
    items: [API_TAG_TYPES.CULTURE_PROJECT, API_TAG_TYPES.PROJECT_DASHBOARD, API_TAG_TYPES.PERSONAL_TRACKER],
  },
  [ACTIVITY_LOG_CATEGORIES.FEEDBACK_FRAMEWORK]: {
    list: API_TAG_TYPES.ORGANISATION_PROJECTS,
    items: [API_TAG_TYPES.FEEDBACK_FRAMEWORK],
  },
};
